import { makeAutoObservable, runInAction } from 'mobx'
import { AxiosError } from 'axios'
import { logger } from 'shared/lib'
import { AuthApi } from 'entities/Auth/api'

const DEFAULT_ERROR = 'Something went wrong. Please try again.'

export class PasswordChangeForcePageStore {
  private _loading = false
  private _success = false
  private _error: string | null = null

  constructor() {
    makeAutoObservable(this)
  }

  get loading() {
    return this._loading
  }

  get success() {
    return this._success
  }

  get error() {
    return this._error
  }

  sendResetPasswordLink = async () => {
    if (this._loading) return
    this._error = null
    try {
      this.setLoading(true)
      await AuthApi.forgotForce()
      runInAction(() => {
        this._success = true
      })
    } catch (e) {
      logger.error(e)
      runInAction(() => {
        this._error = (e instanceof AxiosError && e.errors.first) || DEFAULT_ERROR
      })
    } finally {
      this.setLoading(false)
    }
  }

  setLoading = (value: boolean) => {
    this._loading = value
  }
}
